import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import * as routeHelpers from '../authentication/routeHelpers';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CheckIcon from '@material-ui/icons/Check';
import { makeStyles } from '@material-ui/core/styles';
import { actionCreators as authActions } from '../redux/actions/authActions';
import * as authHelpers from '../authentication/authHelpers';
import LoadingAlert from './../components/LoadingAlert';

class ConsentRequired extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			legalTexts: [],
			errorMessage: '',
			statusMessage: 'Checking acceptance of terms.',
			dialogIsVisible: false,
			canAccept: false
		};

		this.classes = makeStyles(({ palette }) => ({
			root: {
				minWidth: 275,
				maxHeight: '350px',
				overflow: 'auto',
				listStyleType: 'none',
			},
			consentTermText: {
				fontSize: 14,
			},
			button: {
				'&:hover': {
					background: 'none',
				},
			}
		}));
	}

	componentDidMount() {
		let user = authHelpers.getAuthUser();

		if (user && user.consent) {
			this.props.history.push(routeHelpers.buildRoute("")); //navigate to ID Verification component
		}
		else {
			this.checkUserConsent();
		}
	}

	checkUserConsent = () => {
		this.props
			.checkUserConsent()
			.then((legalTexts) => {
				if (legalTexts.length == 0) {
					this.props.history.push(routeHelpers.buildRoute(""));
				}
				this.setState((state) => ({
					...state,
					legalTexts: legalTexts.map(l => ({ ...l, accepted: false })),
					statusMessage: ''
				}));
			})
			.catch((error) => {
				var errorMessage = error?.errorMessage
					? error?.errorMessage
					: 'An unknown error has occurred. Please try again later or contact us for assistance.';

				this.setState((state) => ({
					...state,
					errorMessage: errorMessage,
					statusMessage: ''
				}));
			});
	};

	handleCloseDialog = (reject) => {

		this.setState((state) => ({
			...state,
			dialogIsVisible: false
		}));

		if (reject) {
			this.props.signOut().then(() => {
				this.props.history.push(routeHelpers.buildRoute('/login'));
			});
		}
	};

	legalTextAcceptedChanged = (event, legalText) => {
		legalText.accepted = event.target.checked;
		this.setState((state) => ({
			...state,
			canAccept: this.state.legalTexts.every(l => l.accepted),
		}));
	};

	decline = () => {
		this.setState((state) => ({
			...state,
			dialogIsVisible: true
		}));
	};

	accept = () => {
		var legalTextIDs = this.state.legalTexts.filter(l => l.accepted).map(l => l.ID);

		this.props
			.updateUserConsent(legalTextIDs)
			.then(() => {
				this.props.history.push(routeHelpers.buildRoute(""));
			})
			.catch((error) => {
				var errorMessage = error?.errorMessage
					? error?.errorMessage
					: 'An unknown error has occurred. Please try again later or contact us for assistance.';

				this.setState((state) => ({
					...state,
					errorMessage: errorMessage,
					statusMessage: ''
				}));
			});
	}

	render() {
		return (
			<div style={{ minHeight: `90%`, minWidth: `90%` }}>
				{this.state.statusMessage ? (
					<>
						<LoadingAlert title="Please wait" message={this.state.statusMessage} />
					</>
				) : (
					<>
						<div style={{ marginTop: 20, textAlign: `center` }}>
							<Typography variant='h4' component='h2' color='primary'>
								Acceptance of Terms and Conditions
							</Typography>
						</div>
						<div style={{ marginTop: 20, textAlign: `left` }}>
							<Typography>
								Please take the time to read and review our latest terms and conditions as set out below.
							</Typography>
						</div>
						<p style={{ fontSize: 15, fontWeight: 'bold' }}></p>

						<Card className={this.classes.root}>
							<CardContent>
								<>{<ul className="no-bullets">
									{this.state.legalTexts.map((legalText, i) => {
										return (
											<li key={legalText.ID}>
												<Checkbox checked={legalText.accepted} color='primary' onChange={(e) => this.legalTextAcceptedChanged(e, legalText)} />
												<span>I have read and accept the </span>
												<Button color="secondary" style={{ backgroundColor: 'transparent', textTransform: 'none', padding: '0 0 2px 0' }} href={routeHelpers.buildRoute(`/acceptance-of-terms/${legalText.ID}`)} target='_blank' component={Link}>
													{legalText.Title}
												</Button>
											</li>)
									})}
								</ul>}</>
							</CardContent>
						</Card>
						<div style={{ display: `flex`, justifyContent: `flex-end`, alignItems: `flex-end`, minWidth: `100%` }}>
							<Button
								style={{ marginTop: 20 }}
								variant='contained'
								color='primary'
								size='large'
								disabled={!this.state.canAccept}
								startIcon={<CheckIcon />}
								onClick={() => this.accept()}
							>
								Accept
							</Button>
							<Button
								style={{ marginTop: 20, marginLeft: 20, background: 'FireBrick', color: 'white' }}
								variant='contained'
								size='large'
								startIcon={<CloseIcon />}
								onClick={() => this.decline()}
							>
								Decline
							</Button>

						</div>

						<Dialog
							open={this.state.dialogIsVisible}
							onClose={this.handleCloseDialog}
							aria-labelledby='alert-dialog-title'
							aria-describedby='alert-dialog-description'
						>
							<DialogTitle id='alert-dialog-title'>Are you sure about that?</DialogTitle>
							<DialogContent>
								<DialogContentText id='alert-dialog-description'>
									If you decline the terms you won't be able to use the system.
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<Button onClick={() => this.handleCloseDialog(false)} color='primary'>
									Cancel
								</Button>
								<Button onClick={() => this.handleCloseDialog(true)} color='primary' autoFocus>
									Ok
								</Button>
							</DialogActions>
						</Dialog>
					</>
				)}
			</div>
		);
	}
}

export default connect(
	(state) => state.authentication,
	(dispatch) => bindActionCreators(authActions, dispatch)
)(ConsentRequired);
